/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { getStylist } from 'src/core/themes/luisStylist';

const { styleDiv } = getStylist('TileContent');

const Root = styleDiv('Root', {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    padding: 16
});

const Content = styleDiv('Content', {
    height: '100%',
    overflow: 'auto',
    hyphens: 'auto'
});

/**
 * Used to place content to fill the body of the card between the
 * header and the footer.
 *
 * @param props Contains the children projected in the component.
 */
export const TileContent: React.FunctionComponent<{ children?: React.ReactNode }> = props => (
    <Root>
        <Content>{props.children}</Content>
    </Root>
);
